var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('window-header'),_c('nav',{staticStyle:{"justify-content":"space-between"}},[_c('button',{staticClass:"button button-fill",class:{ disabled: _vm.tabDisabled(_vm.activeTab - 1) },on:{"click":function($event){return _vm.$refs['main-tabs'].prevTab()}}},[_c('fa-icon',{attrs:{"icon":['fas', 'chevron-left']}}),_c('span',[_vm._v(_vm._s(_vm.$t("back")))])],1),(_vm.activeTab < 2)?_c('button',{staticClass:"button button-fill",class:{ disabled: _vm.tabDisabled(_vm.activeTab + 1) },on:{"click":function($event){return _vm.$refs['main-tabs'].nextTab()}}},[_c('span',[_vm._v(_vm._s(_vm.$t("next")))]),_c('fa-icon',{attrs:{"icon":['fas', 'chevron-right']}})],1):_vm._e(),(_vm.activeTab == 2)?_c('button',{staticClass:"button button-fill",class:{ disabled: !_vm.lineasSelected().length },on:{"click":_vm.finalizar}},[_c('span',[_vm._v("Finalizar")])]):_vm._e()]),_c('section',[_c('article',{staticStyle:{"height":"367px"}},[_c('field',{staticStyle:{"top":"9px","left":"5px"},attrs:{"name":"delegacion_id","model":"factura_cliente","widget":"m2o","searchable":"","label":"Delegación","placeholder":"","width":"130px","readonly":_vm.mode == 'edit'}}),_c('field',{staticStyle:{"top":"9px","left":"140px"},attrs:{"name":"ndoc","widget":"char","searchable":"","label":"Nº Liquid.","placeholder":"","width":"67px","readonly":_vm.mode == 'edit'}}),_c('field',{staticStyle:{"top":"9px","left":"210px"},attrs:{"name":"fecha","widget":"date","type":"date","label":"F. Recepción","help":"Fecha","required":"","default":"today","width":"100px","searchable":"","fontweight":"bold"}}),_c('field',{staticStyle:{"top":"8px","left":"312px"},attrs:{"name":"representante_id","model":"factura_cliente","widget":"m2o","label":"Representante","placeholder":"Rep.","required":"","width":"220px","searchable":"","filter":[['activo','=',1]],"fields":[
          'comision_fija_liquidacion',
          'irpf',
          { name: 'impuesto_id', fields: ['valor'] },
          'nacionalidad',
          'penalizacion_forma_pago',
          { name: 'forma_pago_id', fields: ['nombre', 'penalizacion'] },
          {
            name: 'tipos_comision',
            fields: [
              { name: 'comision_id', fields: ['codigo'] },
              'peso_incmerma',
              't',
              'peso_incmerma',
              'peso_directas',
              'peso_indirectas',
              'unidad_directas',
              'unidad_indirectas',
              'beneficio_directas',
              'beneficio_indirectas',
              'venta_directas_metal',
              'venta_directas_metal_ni',
              'venta_indirectas_metal',
              'venta_indirectas_metal_ni'
            ]
          }
        ]},on:{"change":_vm.onChangeRepresentante}}),_c('field',{staticStyle:{"top":"9px","left":"565px"},attrs:{"name":"divisa_id","model":"factura_cliente","widget":"m2o","searchable":"","label":"Liquidar en...","placeholder":"Cód.","width":"90px","readonly":_vm.mode == 'edit'}}),_c('r-tabs',{ref:"main-tabs",staticStyle:{"top":"55px","left":"0px","height":"310px"},attrs:{"wt":_vm.formData.wt,"buttons":['1. Seleccion', '2. Líneas', '3. Pie'],"classButton":_vm.classButtonTabDisabled,"styleButton":'width:33%;'},on:{"active":_vm.onActiveTab}},[_c('div',{staticClass:"tab"},[_c('fieldset',{staticStyle:{"position":"relative","left":"10px","top":"10px","width":"633px","height":"180px"}},[_c('legend',[_vm._v("Datos de selección:")]),_c('span',{staticStyle:{"position":"absolute","top":"40px","right":"295px","width":"95px","text-align":"center"}},[_vm._v("DESDE")]),_c('span',{staticStyle:{"position":"absolute","top":"40px","right":"200px","width":"95px","text-align":"center"}},[_vm._v("HASTA")]),_c('field',{staticStyle:{"top":"70px","right":"295px"},attrs:{"name":"delegacion_desde","widget":"char","label":"Delegacion","inline-label":"","width":"90px"}}),_c('field',{staticStyle:{"top":"70px","right":"200px"},attrs:{"name":"delegacion_hasta","widget":"char","width":"90px"}}),_c('field',{staticStyle:{"top":"100px","right":"295px"},attrs:{"name":"factura_desde","widget":"char","label":"Factura","inline-label":"","width":"90px"}}),_c('field',{staticStyle:{"top":"100px","right":"200px"},attrs:{"name":"factura_hasta","widget":"char","width":"90px"}}),_c('field',{staticStyle:{"top":"130px","right":"295px"},attrs:{"name":"ffactura_desde","widget":"date","type":"date","label":"F. Factura","inline-label":"","width":"90px"}}),_c('field',{staticStyle:{"top":"130px","right":"200px"},attrs:{"name":"ffactura_hasta","widget":"date","type":"date","width":"90px"}})],1),_c('field',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWt),expression:"showWt"}],staticStyle:{"top":"210px","left":"80px"},attrs:{"name":"incluir","widget":"radio","default":"facturas","options":{
              'Incluir todas las facturas y notas': 'facturas_notas',
              'Incluir Sólo facturas': 'facturas',
              'Incluir Sólo Notas': 'notas'
            }}})],1),_c('div',{staticClass:"tab"},[_c('field',{ref:"facturas",staticStyle:{"top":"5px","left":"4px","width":"648px"},attrs:{"structureRef":"liquidacion_comisiones.facturas","name":"facturas","widget":"handsontable","height":150,"width":650,"minRows":1,"customprop":"facturas_customprop","htSettings":_vm.htSettingsFacturas,"columns":[
              {
                name: 'sel',
                header: 'Sel.',
                widget: 'checkbox',
                help: 'Seleccionado'
              },
              {
                name: 'factura_cliente_id.delegacion_id',
                header: 'Delegación',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre',
                showCode: true
              },
              //{ name: 'serie', header: 'T', readOnly: true },
              {
                name: 'factura_cliente_id.ndoc',
                header: 'NºDocumento',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.cliente_id',
                header: 'Cliente',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre_comercial',
                showCode: true
              },
              {
                name: 'factura_cliente_id.fecha',
                type: 'date2',
                header: 'Fecha',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.total',
                header: 'Total',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'factura_cliente_id.divisa_id',
                header: 'Divisa',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre',
                showCode: true
              },
              {
                name: 'factura_cliente_id.cambio',
                header: 'Cambio',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'factura_cliente_id.formapago_id',
                header: 'F.pago',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'descripcion'
              },
              {
                name: 'calculo',
                header: 'Cálculo',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              //HIDDEN:{name:'penalizacion',header:'Penalización',readOnly:true,type:'numeric',numericFormat: { pattern: '0,0.00'}},
              {
                name: 'comision',
                header: 'Comisión',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'tipo_cobro',
                header: 'T.Cob.',
                type: 'select',
                options: ['I', 'T', 'P'],
                help: 'I: indistinto, P: porcentaje, T: total'
              },
              //HIDDEN:{name:'cobrado',header:'T.Cob.',readOnly:true},
              {
                name: 'porcentaje_cobrado',
                header: '%Cob.',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                help: '% cobrado de la factura al cliente'
              },
              {
                name: 'liquidable',
                header: 'Liquidable',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'liquidado',
                header: 'Pagado',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'pendiente',
                header: 'Pendiente',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'liquidar',
                header: 'Liquidar',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'l',
                header: 'Liquidado',
                type: 'checkbox',
                help: 'Marcar la factura como liquidada'
              }
              //HIDDEN: lineas
            ]}}),_c('field',{directives:[{name:"show",rawName:"v-show",value:(_vm.facturaSeleccionada != null),expression:"facturaSeleccionada != null"}],ref:"lineas",staticStyle:{"top":"160px","left":"4px","width":"648px"},attrs:{"structureRef":"liquidacion_comisiones.lineas_factura","name":'facturas.' +
              (_vm.facturaSeleccionada || 0) +
              '.factura_cliente_id.lineas',"widget":"handsontable","height":100,"width":650,"minRows":1,"customprop":"lineas_customprop","htSettings":_vm.htSettingsLineas,"columns":[
              /*{
                name: 'sel',
                header: 'Sel.',
                widget: 'checkbox',
                help: 'Seleccionado'
              },*/
              {
                name: 'ean13',
                header: '|||||||||',
                help: 'Código de barras del artículo',
                readOnly: true
              },
              {
                name: 'articulo_id',
                header: 'Artículo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                noOpen: true,
                fields: [
                  { name: 'thumbnail', fields: ['imagen'] },
                  'tarifa1',
                  'tarifa2',
                  'tarifa3',
                  'tarifa4',
                  'tarifa5',
                  'tarifa6',
                  'tarifa7',
                  'tarifa8',
                  'tarifa9',
                  'tarifa10'
                ],
                readOnly: true
              },
              {
                name: 'descripcion',
                header: 'Descripción',
                readOnly: true
              },
              {
                name: 'c',
                header: 'C',
                type: 'select',
                options: ['D', 'I']
              },
              {
                name: 'com',
                header: 'Com.',
                model: 'comision',
                type: 'm2o',
                label: 'codigo',
                primary: 'codigo',
                noOpen: true
              },
              {
                name: 'unidades',
                header: 'Unid.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'peso',
                header: 'Peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
                readOnly: true
              },
              {
                name: 'precio',
                header: 'Precio',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'descuentos',
                header: 'Dtos.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                sufix: '%',
                readOnly: true
              },
              {
                name: 'totallinea',
                header: 'Total Línea',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'calculo',
                header: 'Cálculo',
                type: 'numeric',
                readOnly: true,
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'comision',
                header: 'Comisión',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              }
              //HIDDEN:comision_manual
            ]}})],1),_c('div',{staticClass:"tab"},[_c('field',{staticStyle:{"top":"10px","left":"20px"},attrs:{"name":"sunumerofactura","widget":"char","label":"Su Nº Factura","width":"110px"}}),_c('field',{staticStyle:{"top":"10px","left":"150px"},attrs:{"name":"fechasufactura","widget":"date","type":"date","label":"Fecha de su Factura","width":"110px"}}),_c('fieldset',{staticStyle:{"position":"relative","left":"10px","top":"50px","width":"250px","height":"61px"}},[_c('legend',[_vm._v("Tipo Nacionalidad")]),_c('field',{staticStyle:{"top":"9px","left":"15px"},attrs:{"name":"nacionalidad","widget":"radio","default":"union_europea","options":{
                Nacional: 'nacional',
                'Extracom.': 'extracomunitario',
                UE: 'union_europea'
              },"inline-label":""}})],1),_c('field',{staticStyle:{"top":"135px","left":"10px"},attrs:{"name":"observaciones","widget":"text","label":"Observaciones","width":"250px","height":"100px"}}),_c('fieldset',{staticStyle:{"position":"relative","left":"270px","top":"-42px","width":"345px","height":"240px"}},[_c('field',{staticStyle:{"top":"10px","right":"15px"},attrs:{"name":"importe_fijo","widget":"float","type":"number","dec":"2","label":"Importe fijo de comisión","inline-label":"","width":"67px","inputStyle":"text-align:right;"}}),_c('field',{staticStyle:{"top":"38px","right":"15px"},attrs:{"name":"importe_calculado","widget":"float","type":"number","dec":"2","label":"Importe calculado de comisión","inline-label":"","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('hr',{staticStyle:{"position":"absolute","top":"60px","right":"15px","width":"250px"}}),_c('field',{staticStyle:{"top":"78px","right":"15px"},attrs:{"name":"base_imponible","widget":"float","type":"number","dec":"2","label":"Base imponible","inline-label":"","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"106px","right":"87px"},attrs:{"name":"ivap","widget":"float","type":"number","dec":"2","label":"IVA","inline-label":"","sufix":"%","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"106px","right":"15px"},attrs:{"name":"iva","widget":"float","type":"number","dec":"2","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"134px","right":"87px"},attrs:{"name":"irpfp","widget":"float","type":"number","dec":"2","label":"IRPF","inline-label":"","sufix":"%","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"134px","right":"15px"},attrs:{"name":"irpf","widget":"float","type":"number","dec":"2","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('hr',{staticStyle:{"position":"absolute","top":"160px","right":"15px","width":"250px"}}),_c('field',{staticStyle:{"bottom":"38px","right":"15px"},attrs:{"name":"total","widget":"float","type":"number","dec":"2","width":"150px","readonly":"","label":"Total a pagar","inline-label":"","inputStyle":"text-align:right; font-weight:normal; font-size: 1.4em!important;"}}),_c('field',{staticStyle:{"right":"15px","bottom":"10px"},attrs:{"name":"formapago","widget":"select","options":{
                Contado: 'contado',
                Transferencia: 'transferencia',
                Pagaré: 'pagare'
              },"inline-label":"","label":"Forma de pago","width":"150px"}})],1)],1)])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }